import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchDialog from './SearchDialog';

const ManagerSearchDialog = ({ open, onClose, onSelect, initialSearchResult, managers = [], loading = false }) => {
    const { t } = useTranslation();

    const columns = [
        { key: 'manager_name', label: t('managers.fields.name') },
        { key: 'partner_name', label: t('common.searchFields.customer') },
        { key: 'telephone', label: t('managers.fields.telephone') },
        { key: 'email', label: t('managers.fields.email') }
    ];

    const renderRow = (manager, StyledTableRow, BodyCell, handleRowClick) => (
        <StyledTableRow
            key={manager.manager_id}
            onClick={() => handleRowClick(manager)}
            aria-label={`${manager.manager_name} (${manager.partner_name || '-'})`}
        >
            <BodyCell>{manager.manager_name || '-'}</BodyCell>
            <BodyCell>{manager.partner_name || '-'}</BodyCell>
            <BodyCell>{manager.telephone || '-'}</BodyCell>
            <BodyCell>{manager.email || '-'}</BodyCell>
        </StyledTableRow>
    );

    const customFilter = (data, searchTerm) => {
        const searchTermLower = searchTerm.toLowerCase();
        return data.filter(manager => {
            const managerName = manager.manager_name?.toLowerCase() || '';
            const partnerName = manager.partner_name?.toLowerCase() || '';
            const email = manager.email?.toLowerCase() || '';
            return managerName.includes(searchTermLower) || 
                   partnerName.includes(searchTermLower) || 
                   email.includes(searchTermLower);
        });
    };

    return (
        <SearchDialog
            open={open}
            onClose={onClose}
            onSelect={onSelect}
            initialSearchResult={initialSearchResult}
            allData={managers}
            title={t('common.search')}
            placeholder={t('common.search')}
            searchKeys={['manager_name', 'partner_name', 'email']}
            columns={columns}
            renderRow={renderRow}
            customFilter={customFilter}
            listTitle={t('managers.list.title')}
            isLoading={loading}
        />
    );
};

export default ManagerSearchDialog;

